import firebase from 'firebase'
import 'firebase/firestore'

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDz3aUg4RubtSpN1ZKIXtpX8N0bm-VbLXk",
    authDomain: "stand-up-149609.firebaseapp.com",
    databaseURL: "https://stand-up-149609.firebaseio.com",
    projectId: "stand-up-149609",
    storageBucket: "stand-up-149609.appspot.com",
    messagingSenderId: "64799192051"
});

// Export the database for components to use.
// If you want to get fancy, use mixins or provide / inject to avoid redundant imports.
export const rtdb = firebaseApp.database();
export const db = firebaseApp.firestore();
export const auth = firebaseApp.auth();
export const storage = firebaseApp.storage();
export const storageRef = firebaseApp.storage().ref();
export const app = firebaseApp


// WEBPACK FOOTER //
// ./src/CUSTOM/helpers/firebase.js